import { render, staticRenderFns } from "./ShouninLocalHeader.vue?vue&type=template&id=8293231a&scoped=true&"
import script from "./ShouninLocalHeader.vue?vue&type=script&lang=ts&"
export * from "./ShouninLocalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninLocalHeader.vue?vue&type=style&index=0&id=8293231a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8293231a",
  null
  
)

export default component.exports